/**
 * 凑单建议工具
 */

/**
 * 计算距离下一档满减的差额并给出凑单建议
 * @param {number} currentTotal - 当前总金额
 * @param {Array} thresholds - [{ threshold, discount }] 按门槛升序
 * @param {Array} personList - [{ name, items: [{itemName, price}] }]
 * @returns {{ gapToNextThreshold: number|null, nextThreshold: number|null, addedDiscount: number, suggestions: Array }}
 */
export function calculateTopUpSuggestions(currentTotal, thresholds, personList) {
  if (!thresholds || thresholds.length === 0) {
    return { gapToNextThreshold: null, nextThreshold: null, addedDiscount: 0, suggestions: [] }
  }

  const sorted = [...thresholds].sort((a, b) => a.threshold - b.threshold)

  // 找到当前已满足的最高档位
  let currentTier = null
  for (const t of sorted) {
    if (currentTotal >= t.threshold) {
      currentTier = t
    } else {
      break
    }
  }

  // 找到下一档
  const nextTier = sorted.find(t => t.threshold > currentTotal)
  if (!nextTier) {
    return { gapToNextThreshold: null, nextThreshold: null, addedDiscount: 0, suggestions: [] }
  }

  const gap = nextTier.threshold - currentTotal
  const addedDiscount = nextTier.discount - (currentTier ? currentTier.discount : 0)

  // 生成凑单建议：按当前每人金额占比分配凑单金额
  const suggestions = []
  const totalCurrent = personList.reduce((sum, p) =>
    sum + (p.items || []).reduce((s, it) => s + it.price, 0), 0)

  if (totalCurrent <= 0) {
    // 没人有商品，按人均分配
    const perPersonGap = gap / personList.length
    personList.forEach(p => {
      suggestions.push({
        personName: p.name,
        suggestedAddAmount: parseFloat(perPersonGap.toFixed(2)),
        reason: `再凑 ${perPersonGap.toFixed(2)} 元即可触发满${nextTier.threshold}减${nextTier.discount}`
      })
    })
  } else {
    personList.forEach(p => {
      const personTotal = (p.items || []).reduce((s, it) => s + it.price, 0)
      const ratio = personTotal / totalCurrent
      const suggestedAmount = parseFloat((gap * ratio).toFixed(2))
      if (suggestedAmount > 0) {
        suggestions.push({
          personName: p.name,
          suggestedAddAmount: suggestedAmount,
          reason: `再凑 ${suggestedAmount.toFixed(2)} 元即可触发满${nextTier.threshold}减${nextTier.discount}`
        })
      }
    })
  }

  return {
    gapToNextThreshold: parseFloat(gap.toFixed(2)),
    nextThreshold: nextTier.threshold,
    addedDiscount,
    suggestions
  }
}
